import { createClient, postRequestFactory, type SaveOperation } from '@infuse/api/common';

export interface ClaimChargingStationPayload {
  chargingStationId: string;
  password: string;
  rootId: string;
  parentId?: string;
}

const client = createClient('/rest');

export const claimingPermissions = {
  CLAIM: 'cpms.claim-charging-station'
};

export const claimChargingStation: SaveOperation<ClaimChargingStationPayload> = postRequestFactory<
  ClaimChargingStationPayload
>(client, {
  pattern: '/claiming/charging-stations',
  permissionId: claimingPermissions.CLAIM
});
